<p-overlayPanel styleClass="notification" #notify appendTo="body" [showCloseIcon]="true">
  <ng-template pTemplate="content">
    <div
      class="d-flex justify-content-between gap-10 flex-wrap align-items-center notificationTitleBox mb-3"
    >
      <h4>Notifications</h4>

      <div class="btnBlock" *ngIf="notifications.length > 0 && unreadCount > 0">
        <p-button styleClass="markBtn" [outlined]="true" (click)="markAllAsRead()">
          <span>Mark all as read</span>
          <img src="/assets/images/html/doubleTick.svg" alt="Mark as read" />
        </p-button>
      </div>
    </div>
    <p-scrollPanel [style]="{ width: '100%', height: '40vh' }" styleClass="notificationScroll">
      <ul class="list-unstyled notificationList">
        <ng-container *ngIf="notifications.length > 0; else emptyState">
          <li *ngFor="let notification of notifications" [class.unread]="!notification.is_read">
            <!-- <div class="unreadDot" *ngIf="!notification.is_read"></div>-->
            <div class="img">
              <img
                width="50%"
                [src]="
                  notification.type === 'post_activity' || notification.type === 'post_status'
                    ? getNotificationIcon(notification.custom_data.type)
                    : getNotificationIcon(notification.type)
                "
                [alt]="notification.type"
              />
            </div>
            <div class="txt">
              <p>{{ getNotificationText(notification) }}</p>
              <span class="time">
                {{ notification.created_at.toDate() | date: 'd MMMM y' }}
                <span class="date">{{ notification.created_at.toDate() | date: 'h:mm a' }}</span>
              </span>
            </div>
            @if (notification.type === 'connection_error') {
              <button
                [routerLink]="['/workspace/settings']"
                [queryParams]="{ selectedTab: 'connected-accounts' }"
                class="reviewBtn"
              >
                Fix
              </button>
            }
            @if (
              notification.type === 'post_status' &&
              (notification.custom_data.type.toLowerCase() === 'needs_approval' ||
                notification.custom_data.type.toLowerCase() === 'failed')
            ) {
              <button
                *ngIf="
                  notification.custom_data.type.toLowerCase() === 'failed' ||
                  notification.custom_data.type.toLowerCase() === 'needs_approval'
                "
                class="reviewBtn"
                (click)="navigateToPlanner(notification.custom_data.type.toLowerCase())"
              >
                Review
              </button>
            }
            @if (
              notification.type === 'post_activity' &&
              notification.custom_data.type.toLowerCase() === 'comment'
            ) {
              <button class="reviewBtn" (click)="navigateToPost(notification.custom_data.post_id)">
                Review
              </button>
            }

            <!-- <div class="unreadMark" *ngIf="!notification.is_read">
              <span></span>
            </div>-->
          </li>
        </ng-container>

        <ng-template #emptyState>
          <li class="emptyNotification">
            <img src="assets/images/html/no-notification.svg" alt="No notifications" />
            <p>No new notifications</p>
          </li>
        </ng-template>
      </ul>
    </p-scrollPanel>

    <!--<div class="seaMore" *ngIf="notifications.length > 0">
      <a href="#" onclick="return false;">See More</a>
    </div>-->
  </ng-template>
</p-overlayPanel>
<a class="nav-link" (click)="notify.toggle($event)">
  <i
    class="pi pi-bell p-text-secondary"
    pBadge
    [value]="unreadCount.toString()"
    severity="danger"
    [hidden]="unreadCount == 0"
    style="font-size: 1.5rem"
  ></i>
  <i class="pi pi-bell p-text-secondary" *ngIf="unreadCount == 0" style="font-size: 1.5rem"></i>
</a>
